import { render, staticRenderFns } from "./ItemNotifications.vue?vue&type=template&id=c22323b6&"
import script from "./ItemNotifications.vue?vue&type=script&lang=js&"
export * from "./ItemNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports